import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  MainContianer: {
    width: "87%",
    margin: "3rem auto auto auto",
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      margin: "1rem auto auto auto",
    },
  },
  FormTitle: {
    "&.MuiTypography-root": {
      marginTop: "3rem",
      fontFamily: theme.fonts.family.secondary,
      fontSize: 16,
      fontWeight: 800,
      color: theme.colors.primary.Darkblue,
      letterSpacing: "0.1em",
    },
  },
  FormContainer: {
    marginTop: "2.5rem",
  },
  Links: {
    textDecoration: "none",
  },
}));
